import axios from "axios";

const baseURL = process.env.REACT_APP_API_BASE_URL;

// ✅ Log only once at startup
if (process.env.NODE_ENV !== "production") {
    console.log("🌐 Using API Base URL:", baseURL);
}

const http = axios.create({
    baseURL,
    headers: { "Content-Type": "application/json" },
});

// Attach accessToken
http.interceptors.request.use((config) => {
    const accessToken = localStorage.getItem("ACCESS_TOKEN");
    if (accessToken) {
        config.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    return config;
});

// Handle expired tokens (optional refresh flow)
http.interceptors.response.use(
    (res) => res,
    async (err) => {
        if (err.response?.status === 401) {
            const refreshToken = localStorage.getItem("REFRESH_TOKEN");
            if (refreshToken) {
                try {
                    const res = await axios.post("/auth/refresh", { refreshToken });
                    localStorage.setItem("ACCESS_TOKEN", res.data.accessToken);
                    err.config.headers["Authorization"] = `Bearer ${res.data.accessToken}`;
                    return axios(err.config); // retry original request
                } catch (refreshErr) {
                    localStorage.clear();
                    window.location.href = "/login";
                }
            }
        }
        return Promise.reject(err);
    }
);

export default http;
